module.exports = __webpack_public_path__ + "static/media/PM138.d23a9aec.png";